<template>
    <v-container id="victim_letter_print">
        <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
        <v-btn color="secondary" id="victim-print-button" @click="print">
            PRINT VICTIM LETTER
        </v-btn>
        <div id="victim-print-form">
            <div class="box">
                <div class="letter-pg1">
                    <div class="letter-header">
                        <div class="lh-flex"> Reno Police Department<br><em>"Your Police, Our Community"</em></div>
                        <div><img class="letter_badge" src="../images/gold-badge.png" alt="Reno nevada police Badge" /></div>
                        <div class="lh-flex-3">Kathryn Nance<br /> <em>Chief of Police</em></div>
                    </div>
                    <div class="letter-body normal">
                        <div class="address">
                            <h6>To: {{vic_ltr_data.vic_name}}</h6>
                            <h6>{{vic_ltr_data.vic_address}}</h6>
                            <h6>{{vic_ltr_data.vic_city}},&nbsp;{{vic_ltr_data.vic_state}},&nbsp;{{vic_ltr_data.vic_zip}}</h6><br>
                            <h6>Date: {{vic_ltr_data.today_date}}</h6><br>
                            <h6>Case#: {{vic_ltr_data.case_num}}</h6>
                        </div>
                        <div class="case-info">
                            <h6 class="line-height-more">Your case has been assigned to a Traffic Division Detective. After careful review of the facts and circumstances of your case, the assigned Detective has:</h6><br>
                            <h6>(&nbsp;&nbsp;&nbsp;) Completed the case and filed it in the Reno Police Records Section.</h6>
                            <h6>(&nbsp;&nbsp;&nbsp;) Arrested or cited the responsible driver.</h6>
                            <h6>(&nbsp;&nbsp;&nbsp;) Suspended the case due to insufficient information available.</h6>
                            <h6>(&nbsp;&nbsp;&nbsp;) Suspended the case due to a lack of evidence or witnesses.</h6>
                            <h6>(&nbsp;&nbsp;&nbsp;) Closed the case due to the inability to locate the suspected driver.</h6><br>
                        </div>
                        <div class="add-info bold">
                            <h6>Additional Information:</h6>
                            <h6>DRIVER:&nbsp;{{vic_ltr_data.driver_name}}</h6>
                            <h6>REGISTERED OWNER:&nbsp;{{vic_ltr_data.reg_owner_name}}</h6>
                            <h6>VEHICLE INFO:&nbsp;{{vic_ltr_data.veh_year}},&nbsp;{{vic_ltr_data.veh_make}},&nbsp;{{vic_ltr_data.veh_model}},&nbsp;{{vic_ltr_data.veh_lic}},&nbsp;{{vic_ltr_data.veh_state}} </h6>
                            <h6>INSURANCE:&nbsp;{{vic_ltr_data.ins_name}},&nbsp;policy#: {{vic_ltr_data.ins_policy_num}},&nbsp;ph#: {{vic_ltr_data.ins_phone}}</h6><br>
                            <h6>COMMENTS: The investigation has been concluded. You may contact records in order to obtain a copy of the report.</h6>
                        </div>
                        <div class="footnote">
                            <h6 class="line-height-more">A complete copy of this case can be obtained for a fee from the Reno Police Records Section at 455 E. 2nd St. Reno, NV. 89501 (775) 334-2155. Records section hours are Monday through Thursday, 9:00 AM to 4:00 PM, however the records section closes for the lunch hour between 12:00 noon and 1:00 PM.  Please call me at {{vic_ltr_data.det_phone}} if you have any questions.</h6><br>
                        </div>
                        <div class="signature">
                            <h6>Sincerly,</h6>
                            <h6><img :src="GenImageLink(vic_ltr_data.det_sig_image)" class="signature-image"/></h6><br>
                            <h6 style="padding-bottom:20px">Reno Police Traffic Division</h6>
                        </div>


                    </div>
                </div>
            </div>
        </div>


    </v-container>
</template>

<style lang="scss" scoped>

    #victim-print-form {
        display: none;
    }

    #victim-print-button {
        display: none;
    }

    .letter_badge {
        max-width: 125px;
        max-height: 125px;
    }

    .letter-header {
        display: inline-flex;
    }
</style>

<script>
    /* eslint-disable */
    import { bus_common } from "../mixins/bus_common";
    import print from 'print-js'
    export default {
        name: "victim_letter_print",
        mixins: [bus_common],
        props: ["vic_ltr_data"],
        data() {
            return {
                showltr: false,
            };
        },
        methods: {

            print: function () {
                this.$htmlToPaper('victim-print-form');
            },
            printjs: function () {
                /* this.addHashToLocation('/my/new/path')*/
                printJS({
                    printable: "victim-print-form",
                    documentTitle: "Victim Letter",
                    type: "html",
                    scanStyles: false,
                    css: './vic_print.css',
                    onLoadingEnd: () => {
                        //setTimeout(() => {
                        //    history.back()
                        //}, 500);
                    }
                });


            },
            addHashToLocation(params) {
                history.pushState(
                    {},
                    null,
                    "/"
                )
            },
            GenImageLink(filename) {
                let link = window.location.origin + "/Upload/" + filename;
                return link
            },
            async init() {

            },
        },
        watch: {

        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
    };
</script>
